import { useContext } from 'react';
import { ScreenContext } from './context';

export const useScreenContext = () => useContext(ScreenContext);
